import { useTranslations } from 'next-intl';
import { Point } from 'fabric';

import { useToolContext } from '@/context/ToolContext';
import toggleLineControlVisibility from '@/utils/toggleLineControlVisibility';

interface HeaderProps {
  onSubmit: () => void;
  onCancel: () => void;
}

const Header = ({ onSubmit, onCancel }: HeaderProps) => {
  const ToolContextState = useToolContext();

  const t = useTranslations();

  const onClick = () => {
    const canvas = ToolContextState.canvasStateRef.current;
    // Reset zoom AND pan before exporting. Fabric's toCanvasElement keeps the live viewport transform
    // (it computes `zoom * multiplier`), so any zoom — the dugout fit-to-field zoom or a mobile pinch —
    // would otherwise be baked into `img_data`, the PNG the host actually stores, cropping away anything
    // outside the zoomed area.
    canvas.setZoom(1);
    canvas.absolutePan(new Point(0, 0));

    toggleLineControlVisibility({ canvas, transitionLength: 0 });

    setTimeout(() => {
      onSubmit();
    }, 1000);
  };

  return (
    <header className="Header">
      <div className="Header-buttons">
        <div className="Header-back">
          <button
            type="button"
            onClick={onCancel}
            aria-label={t('DRWNG__A11Y_BACK')}
            title={t('DRWNG__A11Y_BACK')}
          >
            <svg
              width="10"
              height="16"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 10 16"
            >
              <g transform="translate(-29 -22)" stroke="#253780" fill="none">
                <path id="arrow" d="m38 37-7-7 7-7" />
              </g>
            </svg>
          </button>
        </div>
        <div className="Header-content">
          <svg
            width="23"
            height="26"
            viewBox="0 0 23 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M15 16V25H1V7H14" stroke="#253780" strokeWidth="2" />
            <path
              d="M12.1714 8L14.9998 5.17157L17.8282 8"
              stroke="#C0E9F4"
              strokeWidth="6"
              strokeLinecap="square"
            />
            <path
              d="M4 21C10.0751 21 15 16.0751 15 10"
              stroke="#BEE8F4"
              strokeWidth="6"
            />
            <path
              d="M4 21C10.0751 21 15 16.0752 15 10C15 5.94994 15 4.61661 15 6.00003"
              stroke="#253780"
              strokeWidth="2"
            />
            <path d="M11 9L15 5L19 9" stroke="#253780" strokeWidth="2" />
            <path
              d="M7 15C8.10457 15 9 14.1046 9 13C9 11.8954 8.10457 11 7 11C5.89543 11 5 11.8954 5 13C5 14.1046 5.89543 15 7 15Z"
              stroke="#253780"
              strokeWidth="2"
            />
          </svg>
          <h2 className="Header-title">{t('DRWNG__APPTITLE')}</h2>
        </div>
      </div>
      <div className="Header-buttons">
        <button
          className="Header-saveButton"
          onClick={onClick}
          data-bind="js-legend-toggle"
        >
          {t('DRWNG__BTN_SAVE')}
          <svg
            className="Header-saveButtonIcon"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 6 10"
          >
            <path
              d="M6 5 1.5 0 0 1.5 3 5 0 8.5 1.5 10 6 5Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>
    </header>
  );
};

export default Header;
